import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Container } from '@fiverr-private/layout_components';

import * as SuggestionsSelector from '../../../selectors/Suggestions';
import { setSearch, submitSearch, selectSuggestion } from '../../../actions';
import { PANEL_SOURCE } from '../../../utils/constants';
import { translateSubCategory } from '../../../utils/translation/subCategories';
import { aiPillQuickFilterChipClass } from '../styles.ve.css';

const QuickFilterChip = ({ id, value, isSelected, onClick }) => {
    const handleClick = (e) => {
        e.preventDefault();
        onClick();
    };

    return (
        <Container
            as="button"
            type="button"
            className={classNames(aiPillQuickFilterChipClass, { selected: isSelected })}
            display="inlineFlex"
            alignItems="center"
            paddingX="4"
            paddingY="2"
            borderRadius="circle"
            whiteSpace="nowrap"
            color="grey_1200"
            fontSize="b_sm"
            lineHeight="b_sm"
            fontWeight="semibold"
            onClick={handleClick}
            data-id={id}
        >
            {value}
        </Container>
    );
};

QuickFilterChip.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
};

QuickFilterChip.defaultProps = {
    value: '',
    isSelected: false,
    onClick: () => true,
};

const mapStateToProps = (state, { id }) => {
    const { value, category, isSelected } = SuggestionsSelector.suggestionById(state, id);

    return { search: value, category, isSelected };
};

const mapDispatchToProps = (dispatch, { id }) => ({
    onSelect: (search, category) => {
        dispatch(selectSuggestion(id));
        dispatch(setSearch(search));
        dispatch(submitSearch({ submitSource: PANEL_SOURCE, queryParams: { sub_category: category } }));
    },
});

const mergeProps = ({ search, category, isSelected }, { onSelect }, { id }) => ({
    id,
    isSelected,
    value: translateSubCategory(category),
    onClick: () => onSelect(search, category),
});

export { QuickFilterChip };
export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(QuickFilterChip);
